import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.NetSuiteMatchingPopup', {
    categoryColumnName: 'Category',
    accountColumnName: 'Account',
    taxCodeColumnName: 'Tax code',
    taxRateColumnName: 'Tax rate',
    taxAmountColumnName: 'Tax amount',
    grossAmountColumnName: 'Gross amount',
    memoColumnName: 'Memo',
    departmentColumnName: 'Department',
    classColumnName: 'Class',
    locationColumnName: 'Location',
    isBillableColumnName: 'Billable',
    descriptionColumnName: 'Description',
    billedColumnName: 'Billed',
    quantityColumnName: 'Qty',
    itemColumnName: 'Item',
    vendorNameColumnName: 'Vendor name',
    unitsColumnName: 'Units',
    customerColumnName: 'Customer',
    amountColumnName: 'Amount',
    unitPriceColumnName: 'Rate',
    remainingColumnName: 'Remaining',
    linkedColumnName: 'Linked',
});
